import { baseApi, ENDPOINTS } from '@/shared/api';
import type { FileType } from '@/shared/types/antd';

import type { ChangePassword } from '../model/types/change-password';
import type { ProfileData } from '../model/types/profile';

const profileApi = baseApi
    .enhanceEndpoints({ addTagTypes: ['ViewerData'] })
    .injectEndpoints({
        endpoints: (build) => ({
            uploadAvatar: build.mutation<
                void,
                AwareId & { file: FileType | string | Blob }
            >({
                query: ({ id, file }) => {
                    const formData = new FormData();

                    formData.append('image', file);

                    return {
                        url: ENDPOINTS.viewer.updateAvatar(id),
                        method: 'PATCH',
                        body: formData,
                    };
                },
                invalidatesTags: ['ViewerData'],
            }),
            deleteAvatar: build.mutation<void, number>({
                query: (id) => ({
                    url: ENDPOINTS.viewer.updateAvatar(id),
                    method: 'PATCH',
                    body: { image: null },
                }),
                invalidatesTags: ['ViewerData'],
            }),
            updateProfileData: build.mutation<
                void,
                AwareId & Partial<ProfileData>
            >({
                query: ({ id, ...body }) => ({
                    url: ENDPOINTS.viewer.updateProfileData(id),
                    method: 'PATCH',
                    body,
                }),
                invalidatesTags: ['ViewerData'],
            }),
            changePassword: build.mutation<void, AwareId & ChangePassword>({
                query: ({ id, ...body }) => ({
                    url: ENDPOINTS.viewer.changePassword(id),
                    method: 'PATCH',
                    body,
                }),
            }),
            deleteUserAccount: build.mutation<void, void>({
                query: () => ({
                    url: ENDPOINTS.viewer.deleteUserAccount,
                    method: 'POST',
                }),
            }),
        }),
    });

export const {
    useUpdateProfileDataMutation,
    useUploadAvatarMutation,
    useDeleteAvatarMutation,
    useChangePasswordMutation,
    useDeleteUserAccountMutation,
} = profileApi;
